import { migrateOldDataToNetlify } from "../../utils/migrateOldDataToNetlify";
import { fetchNetlifyAuthToken } from "./netlifyAuthToken";
import { migrateVersionToCardRelationshipsData } from "../../utils/migrateLegacyCardRelationshipsData";
import { trackSentryEvent } from "../../analytics/sentry.js";

const getCardRelationshipsData = async (t) => {
  try {
    // Ensure `t` is not null or undefined
    if (!t) {
      throw new Error("Trello iframe context (t) is not initialized.");
    }

    if (process.env.POWERUP_NAME.includes("LOCAL")) {
      const localCardRelationships = await t.get(
        "organization",
        "shared",
        "localCardRelationships"
      );
      // Handle legacy format for local dev
      if (localCardRelationships && !("version" in localCardRelationships)) {
        // Use migration utility for local dev (skip Netlify POST)
        return await migrateVersionToCardRelationshipsData({
          t,
          orgId: "local-dev",
          token: null,
          legacyData: localCardRelationships,
        });
      }
      return localCardRelationships;
    }

    const org = await t.organization("id");
    const token = await fetchNetlifyAuthToken();
    const response = await fetch(
      `/.netlify/functions/cardRelationshipsApi?organizationId=${org.id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Response was not ok fetching card relationships data: ${response.status}`
      );
    }

    const dataString = await response.json();
    // If no data exists, then run the database migration
    if (response.ok && !dataString) {
      const migratedData = await migrateOldDataToNetlify({
        t,
        orgId: org.id,
      });
      return { version: null, data: migratedData };
    }

    const data = JSON.parse(dataString);
    // Handle legacy format for Netlify
    if (data && !("version" in data)) {
      // Use migration utility to POST new format and return it
      return await migrateVersionToCardRelationshipsData({
        t,
        orgId: org.id,
        token,
        legacyData: data,
      });
    }

    return data; // Expect data to be { version, data }
  } catch (error) {
    console.error("Error fetching card relationships data:", error);
    const org = await t.organization("id");
    trackSentryEvent("getCardRelationshipsData_error", {
      error: error.message,
      organization_id: org.id,
    });
    return { version: null, data: null };
  }
};

export default getCardRelationshipsData;
